module.exports = __webpack_public_path__ + "static/img/carlogo.ab1ff97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/carlogo.png
// module id = 3hy6
// module chunks = 44